/**
 * Types of checklist actions the user can do
 */
export enum ChecklistAction { // eslint-disable-line
  ADD_CONTACT_BULK = 'addContactBulk',
  ADD_CONTACT_SUGGESTED = 'addContactSuggested',
  ADD_CONNECTWISE = 'addConnectwise',
  ADD_NOTE = 'addNote',
  ADD_OUTLOOK = 'addOutlook',
  ADD_REMINDER = 'addReminder',
  ADD_TEAMS = 'addTeams',
  ADD_TEAMS_CALLING = 'addTeamsCalling',
  ANALYSE_PORTFOLIO = 'analysePortfolio',
  ANALYSE_SEGMENT = 'analyseSegment',
  CONNECT_EMAIL = 'connectEmail',
  CREATE_FIRST_SEGMENT = 'createFirstSegment',
  DOWNLOAD_APP = 'downloadApp',
  INTEGRATE_CALENDAR = 'integrateCalendar',
  INTEGRATE_OFFICE365 = 'integrateOffice365',
  INVITE_COLLEAGUES = 'inviteColleagues',
  MANAGER_INVITE_COLLEAGUES = 'managerInviteColleagues',
  REVIEW_YOUR_ACTIVITY = 'reviewYourActivity',
  SETUP_ACCOUNT = 'setupAccount',
  SETUP_CUSTOM_DATA = 'setupCustomData',
  SETUP_PORTFOLIOS = 'setupPortfolios',
  SETUP_SCORING = 'setupScoring',
  USE_CUSTOM_DATA = 'useCustomData',
  WELCOME_PRODUCT_TOUR = 'welcomeProductTour',
}
